<template>
    <div class="warp">
        <div class="echarts" ref="echarts"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'echartsLine',
    props: ['tableData'],
    data() {
        return {
            echartsData: []
        }
    },
    watch: {
        tableData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.initChart(this.tableData)
            })
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    mounted() {},
    methods: {
        initChart(Edata) {
            this.echartsData = Edata
            this.chart = echarts.init(this.$refs.echarts)
            this.chart.setOption(this.getOption())
        },
        getOption: function() {
            return {
                color: ['#0095FF', '#FED836'],
                title: {
                    subtext: '终端系统分布',
                    // left: 'center',
                    // bottom: 60,
                    subtextStyle: {
                        color: '#606266',
                        fontSize: 14
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    x: 'right',
                    top: 70,
                    itemWidth: 12, // 设置宽度
                    itemHeight: 12, // 设置高度
                    data: ['老付费用户', '新付费用户'],
                    textStyle: {
                        fontSize: 12,
                        color: '#606266'
                    }
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['50%', '70%'],
                        center: ['46%', '50%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [
                            {value: this.echartsData[0].paymoney, name: '老付费用户'},
                            {value: this.echartsData[1].paymoney, name: '新付费用户'}
                        ]
                    }
                ]
            }
        }
    }
}
</script>
<style scoped>
.warp {
    width: 100%;
    height: 100%;
}
.echarts {
    width: 100%;
    height: 100%;
}
</style>